// extracted by mini-css-extract-plugin
export default {"features":"KNzbKTUns7g1MhRXIhq_","feature":"GPDS9Z5gzgo7KnUAWYvO"};